import { authenticate } from 'pixabay-api'
import { PIXABAY_KEY } from '../config'

const { searchImages } = authenticate(PIXABAY_KEY)

export default async (key, options = {}) => {
  const { hits, totalHits } = await searchImages(key, { per_page: 120, safesearch: true, ...options })

  return {
    images: hits.map(hit => {
      return { id: hit.id, previewURL: hit.previewURL, largeImageURL: hit.largeImageURL, metadata: hit }
    }),
    totalImages: totalHits
  }
}
